import React from 'react';

const AppUsageList = ({ appUsage }) => {
  // Format time display
  const formatTime = (minutes) => {
    if (minutes < 60) {
      return `${minutes}m`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      
      if (remainingMinutes === 0) {
        return `${hours}h`;
      } else {
        return `${hours}h ${remainingMinutes}m`;
      }
    }
  };
  
  // Calculate total time
  const totalTime = appUsage.reduce((total, app) => total + app.time, 0);
  
  return (
    <div className="space-y-4">
      {appUsage.map((app) => (
        <div key={app.name} className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10 rounded-md bg-gray-100 flex items-center justify-center text-xl">
            {app.icon}
          </div>
          <div className="ml-3 flex-grow">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-gray-900">{app.name}</p>
              <p className="text-sm text-gray-500">{formatTime(app.time)}</p>
            </div>
            <div className="mt-1 w-full bg-gray-200 rounded-full h-1.5">
              <div 
                className="bg-primary h-1.5 rounded-full" 
                style={{ width: `${(app.time / totalTime) * 100}%` }}
              ></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppUsageList; 